import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a2518886")

_pushScopeId("data-v-a2518886")
const _hoisted_1 = { class: "input-nick-new mt-1 relative rounded-2xl bg-gray-200 dark:bg-gray-600 h-14" }
const _hoisted_2 = { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")

  return (_openBlock(), _createBlock("div", {
    class: ['rounded-lg', _ctx.iWidth, _ctx.textPosition, _ctx.iRounded, _ctx.iHeight, _ctx.cssClass]
  }, [
    _withDirectives(_createVNode("label", { class: "block text-lg font-medium text-gray-300" }, _toDisplayString(_ctx.inputPlaceholder), 513), [
      [_vShow, _ctx.showLabel]
    ]),
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.valueState = $event)),
        class: ['bg-gray-200 dark:text-gray-400 text-bp-dark dark:bg-gray-700 min-h-full block w-full pr-10 text-lg rounded-2xl focus:outline-none', _ctx.errorMessage.length > 0 ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : '', _ctx.iPadding],
        cols: _ctx.colCount,
        placeholder: _ctx.inputPlaceholder,
        required: _ctx.requiredField,
        rows: _ctx.rowCount
      }, null, 10, ["cols", "placeholder", "required", "rows"]), [
        [_vModelText, _ctx.valueState]
      ]),
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode(_component_ExclamationCircleIcon, {
          "aria-hidden": "true",
          class: "h-5 w-5 text-red-500"
        })
      ], 512), [
        [_vShow, _ctx.errorMessage.length > 0]
      ])
    ]),
    _withDirectives(_createVNode("p", {
      id: "email-error",
      class: "mt-2 text-sm text-red-600"
    }, _toDisplayString(_ctx.errorMessage), 513), [
      [_vShow, _ctx.errorMessage.length > 0]
    ])
  ], 2))
})